import React from 'react';
import Icon from './Icon';
import './ui.css';

/**
 * The Hive search field. Read-only "button" mode navigates to the store; live
 * mode is a controlled input (used on the Store screen).
 */
export default function SearchBar({
  value,
  onChange,
  onClick,
  readOnly,
  placeholder = 'Search apps, tools or solutions…',
  autoFocus,
}) {
  return (
    <div
      className={`hive-search${readOnly ? ' hive-search-button hive-tap' : ''}`}
      onClick={readOnly ? onClick : undefined}
      role={readOnly ? 'button' : undefined}
      tabIndex={readOnly ? 0 : undefined}
      onKeyDown={readOnly ? (e) => (e.key === 'Enter' || e.key === ' ') && onClick && onClick() : undefined}
    >
      <Icon name="Search" size={18} className="hive-search-icon" />
      {readOnly ? (
        <span className="hive-search-placeholder">{placeholder}</span>
      ) : (
        <input
          className="hive-search-input"
          value={value}
          onChange={(e) => onChange && onChange(e.target.value)}
          placeholder={placeholder}
          autoFocus={autoFocus}
          aria-label="Search apps"
        />
      )}
      <Icon name="SlidersHorizontal" size={18} className="hive-search-trailing" />
    </div>
  );
}
